import { actionTypes } from '../../../types';

// Action creator for generating request
export const loggedInInfluencerChannelList = (payload, callback) => ({
    type: actionTypes.LOGGED_IN_INFLUENCER_CHANNEL_LIST_REQUEST,
    payload,
    callback
});

// Action creator for successful generation
export const loggedInInfluencerChannelListSuccess = (payload) => ({
    type: actionTypes.LOGGED_IN_INFLUENCER_CHANNEL_LIST_SUCCESS,
    payload,
});

// Action creator for failed generation
export const loggedInInfluencerChannelListFailure = (payload) => ({
    type: actionTypes.LOGGED_IN_INFLUENCER_CHANNEL_LIST_FAILURE,
    payload,
});

// Action creator for resetting generation status
export const loggedInInfluencerChannelListReset = () => ({
    type: actionTypes.LOGGED_IN_INFLUENCER_CHANNEL_LIST_RESET,
});

// Action creator for resetting all generation reducer
export const loggedInInfluencerChannelListResetAll = () => ({
    type: actionTypes.LOGGED_IN_INFLUENCER_CHANNEL_LIST_RESET_ALL,
});
